import { ConfigurationSchema } from '@jbrowse/core/configuration'

export { default as stateModel } from './model'
export const configSchema = ConfigurationSchema('AddConnectionWidget', {})
